import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AssetvehicleRoutingModule } from './assetvehicle-routing.module';
import { AssetVehicleDetailsComponent } from './asset-vehicle-details/asset-vehicle-details.component';
import { AssetVehicleLinkComponent } from './asset-vehicle-link/asset-vehicle-link.component';
import { AssetVehicleLandingComponent } from './asset-vehicle-landing/asset-vehicle-landing.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { DialogAssetVehicleEntryComponent } from './dialog-asset-vehicle-entry/dialog-asset-vehicle-entry.component';


@NgModule({
  declarations: [
    AssetVehicleDetailsComponent,
    AssetVehicleLinkComponent,
    AssetVehicleLandingComponent,
    DialogAssetVehicleEntryComponent
  ],
  imports: [
   CommonModule,
   AssetvehicleRoutingModule,
   AcademicFormModule,
   MatSelectModule,
   FormsModule ,
   ReactiveFormsModule,
   MatInputModule,
   MatFormFieldModule,
   MatAutocompleteModule,
   MatCardModule,
   MatPaginatorModule,
   MatTableModule,
   MatSortModule

  ]
})
export class AssetvehicleModule { }
